import { combineReducers } from 'redux';

import themeReducer from './themeReducers';
import currentUserReducer from "./currentUserReducer";
import uxStateReducer from "./uxStateReducer";
import settingsReducer from "./settingsReducer";
import currentClientReducer from "./currentClientReducer";
import {RESET_REDUCER} from "../constants";

const appReducer = combineReducers({
	themeReducer,
	currentUserReducer,
	uxStateReducer,
	settingsReducer,
	currentClientReducer
});

const rootReducer = (state, action) => {
	if (action.type === RESET_REDUCER) {
		state = undefined;
	}

	return appReducer(state, action);
};

export default rootReducer;